<script setup>
import { PhxFocus } from '@phx-styleguides/pia';

defineProps({
  background: {
    type: Object,
    required: true,
  },
  pins: {
    type: Array,
    required: true,
  },
  dark: {
    type: Boolean,
    required: true,
  },
});

const addTracking = (value) => {
  window.tracking.pushEvent({
    event: 'product_highlight_block',
    block_name: value.tracking?.button_type || '',
    block_position: value.tracking?.button_position || '',
  });
};
</script>

<template>
  <phx-focus :background="background" :actions="pins" :dark="dark" @focus:usp-open="addTracking" />
</template>
